import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import type { MenuModulo } from '@features/navigation/models/navigation.model';
import type { ApiResponse } from '@shared/models/api.model';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private readonly http = inject(HttpClient);
    private readonly base = `${environment.apiUrl}/navigation`;

    getMenu() {
        return this.http.get<ApiResponse<MenuModulo[]>>(`${this.base}/menu`);
    }
}
